import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../app";
import { changeScale } from "../../annotation/store/annotationSlice";
import {
  setAnnotatorDocumentInfo,
  setCurrentPage,
} from "../store/AnnotatorSlice";
import { AnnotatorDocumentInfoPayload } from "../interfaces/annotator";
import documentSetDisabledSelector from "../../documentSet/selectors/documentSetDisabledSelector";

const useAnnotatorConfig = () => {
  const dispatch = useAppDispatch();

  const readonly = useAppSelector(documentSetDisabledSelector);

  const { hoveredEntities } = useAppSelector((state) => state.appReducer);

  const { scale } = useAppSelector((state) => state.annotationReducer);

  const { currentPage, error } = useAppSelector(
    (state) => state.annotatorReducer.annotationState,
  );

  const handleCurrentPage = useCallback(
    (page: number) => {
      dispatch(setCurrentPage(page));
    },
    [dispatch],
  );

  const setScale = useCallback(
    (newScale: number) => {
      if (newScale !== scale) {
        dispatch(changeScale(newScale));
      }
    },
    [dispatch, scale],
  );

  const handleAnnotatorInfoDocument = useCallback(
    (payload: AnnotatorDocumentInfoPayload) => {
      dispatch(setAnnotatorDocumentInfo(payload));
    },
    [dispatch],
  );

  return {
    readonly,
    hoveredEntities,
    scale,
    setScale,
    currentPage,
    error,
    setCurrentPage: handleCurrentPage,
    setAnnotatorInfoDocument: handleAnnotatorInfoDocument,
  };
};

export default useAnnotatorConfig;
